import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { Plus } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import EmptyComponent from "@/components/containers/EmptyComponent";
import Button from "@/components/forms/Button";
import DashboardSkeleton from "@/components/loadings/skeleton/DashboardSkeleton";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import { fetchPeriodsQueryOptions } from "@/modules/recognition/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_recognition/recognition/period-reports/",
)({
  beforeLoad: async ({ context }) => {
    throwIfHasNoPermission(context.user, "recognition.recognition-period.view");
    const period = await context.queryClient.ensureQueryData(
      fetchPeriodsQueryOptions(0),
    );
    if (period.data.length > 0) {
      throw redirect({
        to: "/admin/recognition/period-reports/$id",
        params: {
          id: period.data[0].id,
        },
      });
    }

    return {
      crumb: [
        {
          label: context.t("Period Reports", { ns: "recognition.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchPeriodsQueryOptions(0)),
  pendingComponent: DashboardSkeleton,
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("recognition.admin");
  const navigate = useNavigate();
  return (
    <EmptyComponent
      variant="cloud"
      title={t("No appreciation period available.")}
      description={t("Create an appreciation period to get started.")}
      footer={
        <Button
          startIcon={<Plus className="size-5" />}
          onClick={() =>
            navigate({
              to: "/admin/recognition/periods",
            })
          }
        >
          {t("Create Appreciation Period")}
        </Button>
      }
    />
  );
}
